module.exports = __webpack_public_path__ + "img/16581266_S.b37c4fd3.png";